<template>
    <tailwind-layout title="Billing">
        <div class="py-8">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="bg-white bg-rent-risk-blue-100 pt-8 pb-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-8">
                        <div class="relative max-w-xl mx-auto">
                            <svg class="absolute left-full transform translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <svg class="absolute right-full bottom-0 transform -translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                                <defs>
                                    <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                        <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                                    </pattern>
                                </defs>
                                <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                            </svg>
                            <div class="text-center">
                                <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Payment Information
                                </h2>
                            </div>
                            <div v-if="billing_type === 'report'" class="rounded-md bg-yellow-50 p-4 mt-2">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <font-awesome-icon icon="fa-info-circle" class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                                    </div>
                                    <div class="ml-3 text-sm text-yellow-700">
                                        <p>
                                            Payment via the New Report button is not an application for a property.  Payment via this link will purchase a credit check and criminal background check only for your personal use and review.
                                        </p>
                                        <p class="mt-2">
                                        When applying for a property, a prospective tenant must apply via the RentRisk link associated with the property address. Contact the landlord or listing agent for the link.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-12">
                                <form @submit.prevent="store" class="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                                    <div v-if="data['payment_method'] === 1">
                                        <label for="first_name" class="block text-sm font-medium text-gray-700">First name</label>
                                        <div class="mt-1">
                                            <input type="text" v-model="form.first_name" :error="form.errors.first_name" id="first_name" autocomplete="given_name" v-bind:class="(form.errors.first_name)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                            <p v-text="form.errors.first_name" class="text-red-500"></p>
                                        </div>
                                    </div>
                                    <div v-if="data['payment_method'] === 1">
                                        <label for="last_name" class="block text-sm font-medium text-gray-700">Last name</label>
                                        <div class="mt-1">
                                            <input type="text" v-model="form.last_name" :error="form.errors.last_name" id="last_name" autocomplete="family-name" v-bind:class="(form.errors.last_name)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                            <p v-text="form.errors.last_name" class="text-red-500"></p>
                                        </div>
                                    </div>
                                    <div v-if="data['payment_method'] === 1" class="sm:col-span-2">
                                        <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                                        <div class="mt-1">
                                            <input id="email" v-model="form.email" :error="form.errors.email" type="email" autocomplete="email" v-bind:class="(form.errors.email)?'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-red-500 rounded-md':'py-3 px-4 block w-full shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 border-gray-300 rounded-md'">
                                            <p v-text="form.errors.email" class="text-red-500"></p>
                                        </div>
                                    </div>
                                    <div class="sm:col-span-2">
                                        <div class="mt-1">
                                            <div id="payment-element"></div>
                                            <div id="error-message" class="bg-red-600 text-red-200 p-4 rounded-lg mt-8 hidden"></div>
                                        </div>
                                    </div>
                                    <div class="sm:col-span-2 text-center text-gray-600">
                                        <table class="w-full">
                                            <tbody>
                                            <tr>
                                                <td class="font-bold text-left border">Payment Description:</td>
                                                <td class="text-left p-1 border">{{ data['title'] }}</td>
                                            </tr>
                                            <tr v-if="data['value'] !== 'all'">
                                                <td class="font-bold text-left border">Actual Amount:</td>
                                                <td class="text-left p-1 border">${{ data['actual_amount'] }}</td>
                                            </tr>
                                            <tr v-if="data['extra_charges']['amount'] > 0">
                                                <td class="font-bold text-left border">Amount:</td>
                                                <td class="text-left p-1 border">${{ data['amount'] }}</td>
                                            </tr>
                                            <tr v-for="one_time_charge in data.one_time_charges" :key="one_time_charge.id">
                                                <td class="text-left border font-bold">{{ one_time_charge.title }}:</td>
                                                <td class="text-left p-1 border">${{ one_time_charge.latest_payment ? one_time_charge.latest_payment.remaining : one_time_charge.amount }}</td>
                                            </tr>

                                            <tr v-if="data['extra_charges']['amount'] > 0">
                                                <td class="font-bold text-left border">Extra Charges:</td>
                                                <td class="text-left p-1 border">{{ formatCurrency(data['extra_charges']['amount']) }}</td>
                                            </tr>
                                            <tr v-if="data['extra_charges']['amount'] > 0">
                                                <td class="font-bold text-left border">Extra Charges Reason:</td>
                                                <td class="text-left p-1 border">{{ data['extra_charges']['reason'] }}</td>
                                            </tr>
<!--                                            <tr v-if="data['extra_charges']['amount'] > 0">-->
<!--                                                <td class="font-bold text-left border">Extra Days:</td>-->
<!--                                                <td class="text-left p-1 border">{{ data['extra_charges']['overdue_days'] }}</td>-->
<!--                                            </tr>-->
                                            <tr>
                                                <td class="font-bold text-left border">Pay Amount:</td>
                                                <td class="text-left p-1 border">${{ data['subtotal'] }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-bold text-left border">Processing Fee:</td>
                                                <td class="text-left p-1 border">${{ data['processing_fee'] }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-bold text-left border">{{data['payment_method'] === 1 ? 'Stripe Card Fee:' : 'Stripe ACH Fee:'}}</td>
                                                <td class="text-left p-1 border">${{ data['stripe_fee'] }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-bold text-left border">Total to Pay:</td>
                                                <td class="text-left p-1 border text-2xl font-bold">${{ data['total'] }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="sm:col-span-2 flex justify-end">
                                        <inertia-link
                                            title="Back"
                                            :href="route('rented-properties.pay', [data['rented_property_id'], data['type'], data['value']])"
                                            class="mr-2 w-full inline-flex items-center justify-center px-6 py-3 border border-gray-300 rounded-md shadow-sm text-base font-medium text-black bg-white hover:bg-white-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400 disabled:bg-indigo-100">
                                            Cancel
                                        </inertia-link>
                                        <form-button id="purchase-btn" :form="form" :disabled="button_active_state" :data-secret="payment_intent.client_secret" class="ml-0 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-rent-risk-blue-400 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400 disabled:bg-indigo-100" type="submit">
                                            Pay
                                        </form-button>
                                    </div>
                                    <!-- <div class="center mt-4 text-sm leading-6 text-gray-500">
                                        <input type="checkbox" id="checkbox" v-model="checked">
                                        <label for="checkbox">By clicking Purchase, you agree to our <a href='#'>Privacy Policy</a> and <a href='#'>Terms and Conditions</a>.</label>
                                    </div> -->
                                    <div class="sm:col-span-2 text-center">
                                        <span class="text-xs tracking-tight text-gray-500">
                                            By clicking Pay, you agree to our <a :href="route('privacy-policy')" target="_blank" class="underline">Privacy Policy</a> and <a :href="route('terms-and-conditions')" target="_blank" class="underline">Terms and Conditions</a>.
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    <!-- Demo Widget -->
    <DemoWidget
        :page-identifier="'rented-properties.payment'"
        :steps="demoSteps"
        :auto-start="true"
        :show-help-icon="true"
    />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import { computed } from "vue";
import DemoWidget from '@/Components/DemoWidget.vue'
import { getDemoSteps } from '@/Config/demoSteps.js'
import { usePage } from "@inertiajs/vue3";

export default {
    props: {
        publishable_key: String,
        amount: String,
        first_name: String,
        last_name: String,
        billing_type: String,
        user: Object,
        payment_intent: Object,
        data: Array,
    },
    mounted(){
        this.includeStripe('js.stripe.com/v3/', function(){
            this.configureStripe();
        }.bind(this) );
    },
    setup(props) {
        const publishable_key = props.publishable_key;
        const payment_intent = props.payment_intent;
        const user = computed(() => usePage().props.value.auth.user);
        const demoSteps = getDemoSteps('rented-properties.payment');
        return {user, publishable_key, payment_intent, demoSteps};
    },
    components: {
        TailwindLayout,
        FormButton,
        DemoWidget
    },
    remember: 'form',
    data() {
        return {
            button_active_state: false,
            stripeAPIToken: this.publishable_key,
            stripe: null,
            stripeReady: false,
            elements: '',
            card: '',
            form: this.$inertia.form({
                first_name: this.first_name,
                last_name: this.last_name,
                billing_type: this.billing_type,
                email: this.user.email,
                card: null,
                payment_intent: null,
                token: null,
            }),
            style: {
                base: {
                    iconColor: "#c4f0ff",
                    color: "#333",
                    fontWeight: "500",
                    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                    fontSize: "16px",
                    fontSmoothing: "antialiased",
                    ":-webkit-autofill": {
                        color: "#fce883",
                    },
                    "::placeholder": {
                        color: "#333",
                    },
                },
                invalid: {
                    iconColor: "#FFC7EE",
                    color: "#FFC7EE",
                },
            },
        }
    },
    computed: {
        validationErrors(){
            let errors = Object.values(this.errors);
            errors = form.errors.flat();
            return errors;
        }
    },
    methods: {
        formatCurrency(amount) {
            if(!amount) {
                amount = 0;
            }
            amount = parseFloat(amount);
            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })
        },
        beforeMount() {
            adx.initiate(null)
        },
        toggleState: function() {
            this.isActive = !this.isActive;
        },
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        /*
            Configures Stripe by setting up the elements and
            creating the card element.
        */
        configureStripe(){
            this.stripe = Stripe( this.stripeAPIToken );
            const options = {
                clientSecret: this.payment_intent.client_secret,
                // Fully customizable with appearance API.
                appearance: {/*...*/},
            };
            this.elements = this.stripe.elements(options);
            this.paymentElement = this.elements.create('payment', {
                defaultValues: {
                    billingDetails: {
                        name: this.user.name,
                        email: this.user.email,
                    }
                }
            });

            this.paymentElement.mount('#payment-element');
            this.stripeReady = true;
        },
        async store() {
            if (!this.stripeReady || typeof this.stripe?.confirmPayment !== 'function') {
                const messageContainer = document.querySelector('#error-message');
                if (messageContainer) {
                    messageContainer.classList.remove('hidden');
                    messageContainer.textContent = 'Payment system is still loading. Please wait a moment and try again.';
                }
                return;
            }

            this.button_active_state = true;
            var elements = this.elements;
            const {error} = await this.stripe.confirmPayment({
                //`Elements` instance that was used to create the Payment Element
                elements,
                confirmParams: {
                    return_url: route('rented-property.pay-success',{'billing_type':this.billing_type,}),
                },
            });

            if (error) {
                this.button_active_state = false;
                // This point will only be reached if there is an immediate error when
                // confirming the payment. Show error to your customer (for example, payment
                // details incomplete)
                const messageContainer = document.querySelector('#error-message');
                messageContainer.classList.remove("hidden");
                messageContainer.textContent = error.message;
            } else {
                // const messageContainer = document.querySelector('#error-message');
                // messageContainer.classList.add("hidden");
                // Your customer will be redirected to your `return_url`. For some payment
                // methods like iDEAL, your customer will be redirected to an intermediate
                // site first to authorize the payment, then redirected to the `return_url`.
            }
        },
    }
}
</script>
